import React from 'react'
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";



function Chart({pikuPrice}) {

  const options = {
    chart: {
      backgroundColor: "#010304",
      type: "areaspline",
      height: "500px",
    },
    title: {
      text: `<h1 id="chart-title">Piku Price</h1>`,
      align: "left",
      style : {
        color : '#808383',
        fontSize : '14px',
        fontFamily : 'Aeonic_medium',
     }
    },
    subtitle: {
        text: `<h1>$${pikuPrice}</h1>`,
        align: "left",
        style : {
           color : 'white',
           fontSize : '32px',
           fontFamily : 'Aeonic_bold',
           marginTop : 12
        }
    },
    plotOptions: {
      series: {
        fillColor: {
          linearGradient: [0, 0, 0, 300],
          linearGradient: [0, 0, 0, 250],
          stops: [
            [0, Highcharts.color('#26DDF9').setOpacity(1).get('rgba')],
            [1, Highcharts.color('#010304').setOpacity(0).get('rgba')],
          ],
        },
        lineWidth: 1,
      }, 
      },
    credits: {
        enabled: false
      },
    yAxis: {
        visible: false
    },
    series: [{
        data: [2, 3, 4, 4.1 , 4.2 ,4.9 , 7, 3, 4 , 6 , 4, 2, 5, 4 , 2, 5, 7 , 2, 5, 7],
      marker : {
        enabled: false
     },
     color: '#26ddf9',
  }]
  };

 
  return (
    <div id="container">
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
      />
    </div>
  );
}

export default Chart;